import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';

const EndorsedBy: React.FC = () => {
    return (
        <div className={styles.EndorsedBy}>
            <div className="endorsed-by-wrapper">
                <div className="title">ENDORSED BY</div>
                <div className="wrapper">
                    <div className="wrapper-item">
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1747639211927/2.png" />
                    </div>
                    <div className="wrapper-item">
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1747639212132/1.png" />
                    </div>
                    <div className="wrapper-item">
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1747639224520/4.png" />
                    </div>
                    <div className="wrapper-item">
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1747639213098/3.png" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndorsedBy;
